import PositionTable from "./components/PositionTable";

const PositionComponent = () =>{

    return(
        <PositionTable />
    )
}
export default PositionComponent;